import { Injectable, inject } from '@angular/core';
import { EventService } from './event.service';

@Injectable({ providedIn: 'root' })
export class SdmUtilService {
	private eventService = inject(EventService);
	public isAuthenticatedOrNot: Promise<boolean>;
	public isAuthenticated: Promise<void>;

	constructor() {
		this.setupAuthenticationPromises();
	}

	private setupAuthenticationPromises(): void {
		
		// Set up authentication promises that resolve when user is authenticated
		let resolveAuthenticated: () => void;
		let resolveAuthenticatedOrNot: (value: boolean) => void;

		this.isAuthenticated = new Promise<void>((resolve) => {
			resolveAuthenticated = resolve;
		});

		this.isAuthenticatedOrNot = new Promise<boolean>((resolve) => {
			resolveAuthenticatedOrNot = resolve;
		});

		// Listen for authentication events
		this.eventService.on('userAuthenticated').subscribe((payload: { didAuthSucceed: boolean }) => {
			if (payload.didAuthSucceed) {
				resolveAuthenticated();
				resolveAuthenticatedOrNot(true);
			} else {
				resolveAuthenticatedOrNot(false);
			}
		});

		// For development/testing - you can remove this or replace with actual auth check
		// Simulate authentication success after a short delay
		setTimeout(() => {
			this.eventService.emitUserAuthenticated(true);
		}, 100);
	}

	public getErrorPastTime(error: any, Content: any): string {
		const seconds = error.PastTime;

		const numdays = Math.floor(seconds / 86400);
		const numhours = Math.floor((seconds % 86400) / 3600);
		const numminutes = Math.floor(((seconds % 86400) % 3600) / 60);

		let str = Content.getContent("Standard.Now");

		if (numminutes >= 1) str = `${numminutes}\u00A0m`;
		if (numhours >= 1) str = `${numhours}\u00A0h`;
		if (numdays >= 1) str = `${numdays}\u00A0d`;

		return str;
	}
}